export const changePolicyendDateReducer = (state = '', action) => {
  switch (action.type) {
    case "CHANGE_PolicyendDate":
      return action.payload.PolicyendDate;
    default:
      return state;
  }
};
